module.exports = __webpack_public_path__ + "img/icon_bms7.4567831a.jpg";